import { createReducer, on } from '@ngrx/store';
import { ILoginResponse } from 'src/app/interfaces/auth.interface';
import { authLoginSuccess } from '../actions/auth.actions';

export interface IAuthState {
  response: ILoginResponse;
}

export const initialAuthState: IAuthState = {
  response: null
};

export const AuthReducers = createReducer(
  initialAuthState,
  on(authLoginSuccess, (state, { response }) => {
    return {
        ...state,
        response
    };
  })
);
